import gql from 'graphql-tag'

export const ACCOUNT_STATEMENT_REPORTS_QUERY = gql`
    query accountStatementReports(
        $page: Int = 1
        $count: Int = 1000
        $orderField: AccountStatementReportOrderField = DATE_FROM
        $orderDirection: OrderDirection = DESC
        $filterCurrentQueueItemStatus: [QueueItemStatus!]
    ) {
        accountStatementReports(
            page: $page
            count: $count
            order: [{ field: $orderField, direction: $orderDirection }]
            search: {
                current_queue_item_status: $filterCurrentQueueItemStatus
            }
        ) {
            paginatorInfo {
                count
                firstItem
                lastItem
                total
                currentPage
                lastPage
                perPage
                hasMorePages
            }
            data {
                id
                owner {
                    id
                    contact_number
                    first_name
                    last_name
                    gender
                    title
                    consulting_company_name
                    created_at
                    updated_at
                }
                accounts {
                    id
                    type
                    status
                    number
                    name
                    description
                }
                date_from
                date_until
                file_types
                currentQueueItem {
                    id
                    status
                    status_message
                }
                queueItems {
                    id
                    status
                    status_message
                }
                fileStorageItem {
                    id
                    type
                    files {
                        id
                        name
                        size
                        mime_type
                    }
                }
                created_at
                updated_at
            }
        }
    }
`
